// wdh-remotecare-admin-panel
import { WDHRemotecareAdminPanel } from '../../../../wdh-feature/wdh-remotecare-admin-panel';
var remotecareAdminPanel = new WDHRemotecareAdminPanel();
remotecareAdminPanel.run();